import { lotSizeDisplayNames } from "./constants/lotSizeTypes";

export const useLotSizeDisplayText = (lotSize: string) => {
  return (
    lotSizeDisplayNames[lotSize as keyof typeof lotSizeDisplayNames] ?? lotSize
  );
};
